import {
    AboutYouBox,
    AccountCircleFilledIcon,
    EditFilledIcon, ExperienceBox,
    HeaderDescription,
    InputBlock, LayersFilledIcon, QualificationBox,
    SectionTitle, WorkFilledIcon, CameraIcon, PhotoBox,
} from "../ProfilePage.styles";
import MaterialInput from "../../../../components/Inputs/MaterialInput/MaterialInput";
import {FormMaterialInput} from "../../../../components/Inputs/MaterialInput/FormMaterialInput";
import MaskedInput from "react-input-mask";
import React, {FC, useEffect, useRef, useState} from "react";
import {useForm, useWatch} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import {AutocompleteProps, HygienistProps, PositionProps, SkillsProps, HYGIENIST_TYPES} from "../../../../utils/types";
import {exitReact, getTypeByRoleNumber, mimeTypeToExtension} from "utils";
import {useHistory} from "react-router";
import joi from "joi";
import {Autocomplete} from "../../../../utils/autocomplete";
import styles from "../../../dentist/PostJobPage/PostJob.module.scss";
import {Switch} from "@mui/material";
import dayjs from "dayjs";
import FullscreenModal from "../../../../components/FullscreenModal";
import _ from "lodash";

import Api from "../../../../api";
import {CrossButtonBlack} from "../../../../components/Buttons/CrossButton";
import clsx from "clsx";
import {SimpleModal} from "../../../../components/Modal";
import {StyledButton} from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import * as ls from "local-storage";
import FixedLoader from "components/FixedLoader";

// @ts-ignore
const TempStars = window.TempStars;

const schema = joi
    .object({
        firstName: joi.string().label('First Name').required(),
        lastName: joi.string().label('Last Name').required(),
        address: joi.string().label('Address').required(),
        city: joi.string().label('City').required(),
        province: joi.string().label('Province').required(),
        postalCode: joi.string().label('Postal Code').required(),
        phone: joi.string().label('Phone').required(),
        photoUrl: joi.string().label('Photo Url').allow(null),
        eTransferEmail: joi.string().email({ tlds: { allow: false } }).label('E-transfer Email').allow(null, ''),
        weeklyNewsletter: joi.boolean().label('Weekly Newsletter').required(),
        priorityNotifications: joi.boolean().label('Priority Notifications').required(),
        receivePostedShifts: joi.boolean().label('Receive Posted Shifts').required(),
    })
    .required()


const filterPhoneNumberToFormat = (phoneNumber: string | undefined): number => {
    const arr = phoneNumber?.match(/\d+/g)
    return Number(arr?.slice(1).join(''))
}

const uploadPhoto = async (imageSrc: any, userId: number, imageType: string) => {
	const ext = mimeTypeToExtension(imageType)
	if (!ext.length) {
        return console.log('unknown image type')
	}

	try {
		const blob = TempStars.File.convertDataURItoBlobSync(imageSrc);
		const result = await TempStars.Api.getAwsUploadCredentials(imageType, userId + '_' + dayjs().unix() + '.' + ext)
		await TempStars.Ajax.upload(result.signedRequest, blob, {contentType: imageType})
		return result.url
	} catch (e: any) {
        return console.log('unknown image type')
	}
}

// TODO: Implement viewStripeAcc as part of React
const viewStripeAcc = async (hygienistId: number, stripeActiveStatus: boolean) => {
    return TempStars.Pages.Hygienist.Profile.viewStripeAcc(hygienistId, stripeActiveStatus)
}

export const Profile: FC<{
    hygienist: {
        skills: SkillsProps[],
    } & HygienistProps,
    setOpenAboutModal: () => void,
    setOpenPositionModal: () => void,
    setOpenQualificationModal: () => void,
    setOpenSuccessModal: () => void,
    workExperience: PositionProps[],
    isAboutChanged: boolean,
    onSubmit: (e: any) => void
}> = (
    {
        hygienist,
        workExperience,
        setOpenAboutModal,
        setOpenPositionModal,
        setOpenQualificationModal,
        isAboutChanged,
        onSubmit,
    }) => {
    const history = useHistory();

    const userAccount: {
        email: string;
        dentistId?: number,
        hygienistId?: number,
        dentist?: any,
        hygienist?: any
        id: number
    } = ls.get('userAccount') || {}

    const inputPhotoRef = useRef<HTMLInputElement>(null)
    const [imageSrc, setImageSrc] = useState<string | null>(hygienist?.photoUrl);
    const [imageType, setImageType] = useState<string>('');
    const [shortAddress, setAddress] = useState<string | undefined>(hygienist?.address);
    const isHygienistOrAssistant = hygienist?.type in [HYGIENIST_TYPES.HYGIENIST, HYGIENIST_TYPES.ASSISTANT];
    const [onExitModal, setOnExitModal] = useState(false)
    const [stripeActiveStatus, setStripeActiveStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    
    const [visibleAddress, setVisibleAddress] = useState('');
    const addressInputRef = useRef<HTMLInputElement>(null);

    const [prevData, setPrevData] = useState({
        firstName: hygienist?.firstName,
        lastName: hygienist?.lastName,
        province: hygienist?.province,
        city: hygienist?.city,
        postalCode: hygienist?.postalCode,
        address: hygienist?.address + ', ' + hygienist?.city + ' ' + hygienist?.province,
        phone: '+1' + hygienist?.phone,
        photoUrl: hygienist?.photoUrl || null,
        eTransferEmail: hygienist?.etransferEmail,
        weeklyNewsletter: !!hygienist?.WeeklyNewsletter,
        priorityNotifications: !!hygienist?.PriorityNotifications,
        receivePostedShifts: !!hygienist?.receivePostedShifts,
    })

    const {
        control,
        handleSubmit,
        setValue,
        formState: {errors},
        setError,
        getValues,
        register,
    } = useForm({
        defaultValues: prevData as any,
        resolver: joiResolver(schema) as any,
    });

    const priorityNotifications = useWatch({control, name: "priorityNotifications"})
    const receivePostedShifts = useWatch({control, name: "receivePostedShifts"})
    const weeklyNewsletter = useWatch({control, name: "weeklyNewsletter"})

    useEffect(() => {
        if (hygienist?.address && hygienist?.city && hygienist?.province) {
            setVisibleAddress(`${hygienist.address}, ${hygienist.city} ${hygienist.province}`);
        }
    }, [hygienist?.address, hygienist?.city, hygienist?.province]);

    useEffect(() => {
        interface EffectiveAutocompleteData {
            state: string;
            city?: string;
            postalCode?: string;
            address?: string;
            buildingNumber?: string;
            street?: string;
            subpremise?: string;
            valueEqual?: boolean;
        }

        const timerId = setTimeout(() => {
            if (!addressInputRef.current) {
                return
            }
            Autocomplete.init(
                { country: hygienist?.country },
                (data: EffectiveAutocompleteData) => {
                    const {
                        state: province,
                        city,
                        postalCode,
                        address: streetAddress,
                        valueEqual
                    } = data;

                    if (valueEqual && streetAddress && city && province) {
                        const fullAddressString = `${streetAddress}, ${city} ${province}`;

                        setVisibleAddress(fullAddressString);
                        setValue('address', fullAddressString, { shouldValidate: true, shouldDirty: true });
                        setValue('city', city, { shouldValidate: true, shouldDirty: true });
                        setValue('province', province, { shouldValidate: true, shouldDirty: true });
                        setValue('postalCode', postalCode || '', { shouldValidate: true, shouldDirty: true });
                        setAddress(streetAddress);
                    }
                }
            );
        }, 0);

        TempStars.Api.checkCreationStatus(hygienist.id, true).then((status: boolean) => setStripeActiveStatus(status));

        return () => {
            clearTimeout(timerId);
            Autocomplete.removeListener();
        };
    }, [hygienist?.country, hygienist?.id, setValue, setAddress, setVisibleAddress]);

    const webPhotoHandler = (photoUrl: any) => {
        const file = photoUrl.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            if(event) {
                setImageSrc(event?.target?.result as string)
                setImageType(file.type as string)
                setValue('photoUrl', event?.target?.result as string)
            }
        };
        reader.readAsDataURL(file);
    }

    const lastPosition = workExperience[workExperience.length - 1]
    const qualifications = hygienist?.skills?.filter((skill: SkillsProps) =>
        skill.license === 0 && skill.qualification === 0
    ).map((skill: SkillsProps) => skill.label).join(',\n')

    const phoneHandler = (e: any) => {
        setValue('phone', e.target.value)
    }

    const profileSubmitHandler = async (data: any) => {
        setLoading(true)
        const isEqual = _.isEqual({...data}, {...prevData})

        if (isEqual && !isAboutChanged) {
            setLoading(false)
            return
        }

        const filteredPhone = filterPhoneNumberToFormat(data.phone)
        if (filteredPhone) {
            if (filteredPhone.toString().length < 10) {
                setLoading(false)
                return setError('phone', {type: "manual", message: "Phone number is too short."});
            } else {
                try {
                    const type = getTypeByRoleNumber(Number(hygienist.type));
                    await Api.checkUniqueHygienistPhoneNumber({phone: filteredPhone, type})
                } catch (e: any) {
                    setLoading(false)
                    return setError('phone', {type: "manual", message: "Oops! This phone number seems to already be in use."});
                }
            }
        }

        setPrevData({...data})

        if (hygienist?.address !== data.address) {
            data.address = shortAddress
        }

        let photoFileName = data.photoUrl

        if (imageSrc && imageType) {
            photoFileName = await uploadPhoto(data.photoUrl, userAccount.id, imageType as string);
            if (photoFileName) {
                photoFileName = photoFileName || '';
            }
        }
        

        setLoading(false)
        return onSubmit({
            ...data,
            photoUrl: photoFileName,
            photo: imageSrc,
            phone: filteredPhone || hygienist?.phone,
        })
    }

    function goToDeleteAccount(){
        const firstName = hygienist?.firstName
        history.push('hygienistDeleteAccount', {firstName: firstName})
    }

    const onExit = () => {
        history.push('loading')
        if(isHygienistOrAssistant) {
            exitReact('home')
        } else {
            history.push('jobPostsList')
        }
    }

    const exitWithSaving = async (data: any) => {
        setOnExitModal(false);
        await profileSubmitHandler(data);
        onExit();
    }

    const onCloseHandler = (data: any) => {
        const isEqual = _.isEqual({...data}, {...prevData})

        if (isEqual && !isAboutChanged) {
            return onExit()
        } else {
            setOnExitModal(true)
        }
    }

    return (
        <>
            <SimpleModal isOpen={onExitModal}>
                <>
                    <div className={styles.titleContainer}>
                        <div className={styles.popupTitle}>Profile</div>
                        <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                          onClick={() => setOnExitModal(false)}/>
                    </div>
                    <div className={styles.description}>
                        Please remember to save your changes before exiting.
                    </div>
                    <StyledButton
                        variant="outlined"
                        size="large"
                        onClick={handleSubmit(exitWithSaving)}
                    >
                        Save and Exit
                    </StyledButton>
                    <StyledButton
                        variant="outlined"
                        size="large"
                        onClick={() => {
                            setOnExitModal(false);
                            onExit();
                        }}
                    >
                        Exit Without Saving
                    </StyledButton>
                </>
            </SimpleModal>

            <FullscreenModal
                title={'Edit Profile'}
                isOpen={true}
                buttonText={'Update'}
                deleteButtonText="Delete My Account"
                onClose={handleSubmit(onCloseHandler)}
                onSubmit={handleSubmit(profileSubmitHandler)}
                onDelete={goToDeleteAccount}
                stickyBottom={false}           
                >
                <HeaderDescription>Add/Change your Profile Information here</HeaderDescription>

                    <PhotoBox className="list-block inset inputBox">
                        <input
                            style={{display: 'none'}}
                            type='file'
                            name={'photoUrl'}
                            ref={inputPhotoRef}
                            onChange={(e: any) => webPhotoHandler(e.target)}
                            accept="image/gif,image/jpeg,image/png,image/jpg,image/*"
                        />

                        <div
                            className={'profile-photo-parent no-fastclick'}
                            onClick={() => {
                                if (imageSrc) {
                                    setImageSrc(null);
                                    setImageType('');
                                    setValue('photoUrl', null);
                                } else {
                                    inputPhotoRef.current?.click();
                                }
                            }}
                        >
                            {imageSrc
                                ? <img className={'photoImg'} src={imageSrc} alt="profilePhoto"/>
                                : <CameraIcon/>
                            }
                        </div>
                    </PhotoBox>

                    <InputBlock className="list-block inset">
                        <MaterialInput
                            label="First Name"
                            type={"text"}
                            id={'fName'}
                            name={"firstName"}
                            disabled={true}
                            defaultValue={hygienist?.firstName}
                        />
                        <MaterialInput
                            label="Last Name"
                            id={'lName'}
                            name={"lastName"}
                            type={"text"}
                            disabled={true}
                            defaultValue={hygienist?.lastName}
                        />
                    </InputBlock>
                    <InputBlock className="list-block inset">
                        <MaterialInput
                            className={'no-fastclick'}
                            label="Mailing Address"
                            id={'autocomplete'}
                            name={"address"}
                            type={"text"}
                            value={visibleAddress}
                            inputRef={addressInputRef}
                            onChange={(e) => {
                                setVisibleAddress(e.target.value);
                            }}
                            error={!!errors?.address}
                            helperText={errors?.address?.message as string}
                            shrink={true}
                        />

                        {/* @ts-ignore */}
                        <MaskedInput
                            mask="+1(999) 999-9999"
                            defaultValue={getValues('phone')}
                            onChange={phoneHandler}
                        >
                            {/* @ts-ignore */}
                            {(inputProps: any) => (<MaterialInput
                                {...inputProps}
                                id={'phone'}
                                name={"phone"}
                                type={'text'}
                                label={'Cell Phone'}
                                error={!!errors?.phone}
                                helperText={errors?.phone?.message}
                            />)}
                        </MaskedInput>
                    </InputBlock>
                {isHygienistOrAssistant && <InputBlock className="list-block inset">
                    <FormMaterialInput
                        control={control}
                        label="E-transfer Email"
                        type={"text"}
                        id={'eTransferEmail'}
                        name={"eTransferEmail"}
                    />
                    <div></div>
                </InputBlock>}

                {isHygienistOrAssistant && <InputBlock className="list-block inset">
                    <StyledButton
                        variant="contained"
                        size="large"
                        onClick={() => viewStripeAcc(hygienist?.id, stripeActiveStatus)}
                    >
                        {stripeActiveStatus ? 'View Express Payouts' : 'Set Up Express Payouts'}
                    </StyledButton>
                    <div></div>
                </InputBlock>}

                    <AboutYouBox className="list-block inset" onClick={setOpenAboutModal}>
                        <SectionTitle>
                            <div>
                                <AccountCircleFilledIcon/>
                                About Me
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {hygienist?.about || 'Add a catchy bio with our AI.'}
                        </div>
                    </AboutYouBox>

                    {isHygienistOrAssistant &&
                    <QualificationBox className="list-block inset" onClick={setOpenQualificationModal}>
                        <SectionTitle>
                            <div>
                                <LayersFilledIcon/>
                                Qualifications & Skills
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {qualifications}
                        </div>
                    </QualificationBox>
                    }

                    <ExperienceBox className="list-block inset" onClick={setOpenPositionModal}>
                        <SectionTitle>
                            <div>
                                <WorkFilledIcon/>
                                Work Experience
                            </div>
                            <EditFilledIcon/>
                        </SectionTitle>
                        <div className="roundedBoxDescription">
                            {lastPosition ? `${lastPosition.jobTitle}, ${lastPosition.companyName}\n${dayjs(lastPosition.fromDate).format('MMM YYYY')} - ${dayjs(lastPosition.toDate).format('MMM YYYY')}`
                                : 'Where have you worked before?'}
                        </div>
                    </ExperienceBox>
                    {isHygienistOrAssistant &&
                    <div className={styles.leftContainer}>
                        <Switch
                            {...register("weeklyNewsletter")}
                            checked={weeklyNewsletter}
                            name="weeklyNewsletter"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                        <div className={styles.instaBook}>Receive Weekly E-mail</div>
                    </div>
                    }

                    <div className={styles.leftContainer}>
                        <Switch
                            {...register("priorityNotifications")}
                            checked={priorityNotifications}
                            name="priorityNotifications"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                        <div className={styles.instaBook}>Notify me when a Pro or Elite status dental office posts an available position on the Job Board</div>
                    </div>
                    {isHygienistOrAssistant && 
                    <div className={styles.leftContainer}>
                        <Switch
                            {...register("receivePostedShifts")}
                            checked={receivePostedShifts}
                            name="receivePostedShifts"
                            inputProps={{'aria-label': 'secondary checkbox'}}
                        />
                        <div className={styles.instaBook}>Receive Temping Shift Notification E-mails</div>
                    </div>
                    }
            </FullscreenModal>

            <FixedLoader
                loading={loading}
            />
        </>
    )
}